<script setup lang="ts">
import type { MenuItem } from '~/types/menu/MenuItem'

defineOptions({
  name: 'NavigationComponent'
})

const properties = defineProps({
  items: {
    type: Array as () => MenuItem[],
    required: true
  },
  active: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <nav aria-label="Hauptnavigation" class="d-flex align-center">
    <template v-for="item of properties.items" :key="item.href">
      <NuxtLink
        :to="item.href"
        class="menu-links"
        :aria-current="item.href === properties.active ? 'page' : undefined"
      >
        <span :class="item.href === properties.active ? 'text-primary' : ''">{{ item.title }}</span>
      </NuxtLink>
    </template>
  </nav>
</template>

<style scoped lang="scss">
.menu-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding: 0;
  margin: 0 0 0 2rem;
  list-style: none;
  font-weight: 400;
  color: rgba(var(--v-theme-textSecondary), 1);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: rgba(var(--v-theme-primary), 1);
  }
}
</style>
